import React, { useState, useEffect, useCallback } from "react";
import api from "../../api";
import { _Team, _Category, _Space, _Active, SType } from "./types";
import { useTranslation } from "../../context";
import { ICurrentRouteInfo } from "../../types";
import { Breadcrumb } from "antd";
import qs from "query-string";
import { changeEgovUrl } from "@/utils/tools";
import { getWebEnvObj } from "@/utils";
const {
  REACT_APP_OSS_BASE_URL = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com"
} = getWebEnvObj();
interface IProps {
  setAddabled: (flag: boolean) => void;
  active: _Active;
  setActive: (a: _Active) => void;
  type: SType;
  categoriesInterceptor?: (c: _Category[]) => _Category[];
  currentRouteInfo?: ICurrentRouteInfo;
}

function dbClick<T>(callback: () => void, select?: () => void) {
  let s = Date.now();
  return () => {
    const e = Date.now();
    if (e - s < 300) {
      return callback();
    }
    s = e;
    select?.();
  };
}

function getSpaces(id: string) {
  return api.space.getSpaces(id).then((data) => data ?? []) as Promise<_Space[]>;
}

function getCategories(id: string, flag?: boolean) {
  // console.log(id, 'id======> ');
  const get = flag ? api.pages.mySpaceCategories : api.pages.spaceCategories;
  return get(id).then((data) => data ?? []) as Promise<_Category[]>;
}

export default function (props: IProps) {
  const { setAddabled, active, setActive, type, categoriesInterceptor, currentRouteInfo } = props;
  const [spaces, setSpaces] = useState<_Space[]>([]);
  const [categories, setCategories] = useState<_Category[]>([]);
  const [breadcrumDatas, setBreadcrumDatas] = useState<
    { name: string; id?: string; type?: string }[]
  >([]);

  const lang = useTranslation();
  const __categoriesInterceptor = React.useCallback(
    (items) => (categoriesInterceptor ? categoriesInterceptor(items) : items),
    [categoriesInterceptor]
  );

  useEffect(() => {
    const getBreadcrumDatas = async () => {
      const { parent, type } = active;
      const isMySpace = !currentRouteInfo?.spaceId && !currentRouteInfo?.teamId;
      const pathInfo = currentRouteInfo?.categoryId
        ? await api.categories.paths(currentRouteInfo.categoryId)
        : null;

      if (type === "space") {
        setBreadcrumDatas([{ name: "团队空间" }, { name: parent?.name || "" }]);
      } else if (currentRouteInfo?.categoryId && isMySpace) {
        pathInfo.paths.pop();
        setBreadcrumDatas([{ name: "我的空间" }, ...pathInfo.paths]);
      } else if (currentRouteInfo?.categoryId) {
        // 团队空间文件夹只有一层，目前不支持嵌套
        if (!pathInfo?.paths) return;
        pathInfo.paths.pop();
        setBreadcrumDatas([
          { name: "团队空间" },
          { name: pathInfo.space.name, id: pathInfo.space.id }
        ]);
      } else {
        setBreadcrumDatas([{ name: "我的空间" }]);
      }
    };
    getBreadcrumDatas();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const getBreadcrumDatas = async () => {
      const { parent, type, category, space, team } = active;
      const pathInfo = category?.id ? await api.categories.paths(category.id) : null;

      let isMySpace = false;
      if (!team || parent?.name === "我的空间") {
        isMySpace = true;
      }
      if (isMySpace) {
        if (category?.id) {
          setBreadcrumDatas([{ name: "我的空间" }, ...pathInfo.paths]);
        } else {
          setBreadcrumDatas([{ name: "我的空间" }]);
        }
      } else if (type === "space") {
        setBreadcrumDatas([{ name: "团队空间" }, { name: team?.name || "", id: team?.id }]);
      } else if (space) {
        setBreadcrumDatas([
          { name: "团队空间" },
          { name: team?.name || "", id: team?.id },
          { name: parent?.name || "", id: space?.id }
        ]);
      } else {
        setBreadcrumDatas([{ name: "团队空间" }, { name: team?.name || "", id: team?.id }]);
      }
    };
    getBreadcrumDatas();
  }, [active]);

  useEffect(() => {
    setAddabled((!active.team && type !== "space") || (!!active.space && !active.category));
  }, [active, setAddabled, type]);

  const __setCategories = (items: _Category[]) => {
    setCategories(items);
    setSpaces([]);
  };

  useEffect(() => {
    const { category, space, team } = active;
    if (category) {
      getCategories(category.id, !team).then(__categoriesInterceptor).then(__setCategories);
    } else if (space) {
      getCategories(space.id)
        .then(__categoriesInterceptor)
        .then((items) => {
          __setCategories(items);
        });
    } else if (team) {
      getSpaces(team.id).then((items) => {
        setCategories([]);
        setSpaces(items);
      });
      // 只能选择空间模式
    } else if (type !== "space") {
      getCategories("root", !team).then(__categoriesInterceptor).then(__setCategories);
    }
  }, [active, type, __categoriesInterceptor, lang, currentRouteInfo]);

  function changeBreadcrumb(item: { name: string; id?: string }, index: number) {
    if (index === breadcrumDatas.length - 1 || item.name === "团队空间") return;
    if (item.name === "我的空间") {
      setActive({ parent: { name: "我的空间" } });
    } else if (index === 1 && breadcrumDatas[0].name === "团队空间") {
      setActive({
        team: { id: item?.id || "", name: item.name },
        type: "space",
        parent: { name: item.name }
      });
    } else {
      getCategories(item.id || "", true)
        .then(__categoriesInterceptor)
        .then(__setCategories);
    }

    setBreadcrumDatas(breadcrumDatas.slice(0, index + 1));
  }

  return (
    <div data-list>
      <div>
        <Breadcrumb separator=">">
          {breadcrumDatas.map((item, index) => (
            <Breadcrumb.Item key={index} onClick={() => changeBreadcrumb(item, index)}>
              {item.name}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>
      <ul>
        {categories?.map((category) => {
          // 双击事件
          const dbhandle = () => {
            // 团队空间只支持一级目录
            if (active.space) {
              return;
            }
            setActive({
              ...active,
              category,
              parent: {
                name: category.name,
                handle: () => setActive({ ...active })
              }
            });
          };
          // 单击事件
          const handle = () => {
            const isSelected = active.selected?.id === category.id;
            setActive({
              ...active,
              type: isSelected ? null : "category",
              selected: isSelected ? null : category
            });
          };
          return (
            <li
              key={category.id}
              onClick={dbClick(dbhandle, handle)}
              className={
                active.type === "category" && active.selected?.id === category.id ? "selected" : ""
              }
            >
              <img
                src={changeEgovUrl(`${REACT_APP_OSS_BASE_URL}/statics/images/joyspace/folder.png`)}
              />
              <span> {category.name}</span>
            </li>
          );
        })}

        {spaces?.map((space) => {
          // 空间双击事件
          const dbhandle = () => {
            if (type === "space") {
              return;
            }
            setActive({
              ...active,
              space,
              type: null,
              parent: {
                name: space.name,
                handle: () => setActive({ ...active })
              }
            });
          };
          // 空间单击事件
          const handle = () => {
            if (type === "category") {
              return;
            }
            const isSelected = active.selected?.id === space.id;
            setActive({
              ...active,
              type: isSelected ? null : "space",
              selected: isSelected ? null : space
            });
          };
          return (
            <li
              key={space.id}
              className={
                active.type === "space" && active.selected?.id === space.id ? "selected" : ""
              }
              onClick={dbClick(dbhandle, handle)}
            >
              {space.avatar_url?.startsWith("https") || space.avatar_url?.startsWith("http") ? (
                <img
                  src={changeEgovUrl(
                    `${qs.parseUrl(space.avatar_url).url}?appKey=${
                      qs.parseUrl(space.avatar_url).query?.appKey
                    }`
                  )}
                  alt=""
                />
              ) : (
                <span data-no-image />
              )}
              {/* <img src={changeEgovUrl(space.avatar_url)} /> */}
              {space.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
